import {sortBy} from 'lodash';

export default function (getVehicle, $stateParams, updateMileageExcludedStatus, toaster, openKeeperModal, openAddNoteModal, $scope, currentUser, $state, tagSwitchService, getAllEnquiryTags, openCloseInvestigationModal, authorizationToken, openEditVehicleModal, openCreateLetterModal, openAddMileageModal, openEditMileageModal, openCreateKeeperModel, keeperMove, keeperDelete, keeperContact) {
    const vm = this;

    vm.details = null;
    vm.enquiries = [];
    vm.keepers = [];
    vm.mileages = [];
    vm.enquiries = [];
    vm.dealers = [];
    vm.vehicleId = $stateParams.vehicleId;
    vm.lastEnquiryId = null;
    vm.notes = [];
    vm.discrepancies = [];
    vm.previousVrms = [];
    vm.lettersSearch = {};
    vm.currentUser = null;
    vm.token = authorizationToken;
    vm.selectedEnquiryProgress = 'current';
    vm.contact = null;
    vm.histories = [];
    vm.queryStringToken = localStorage.getItem('token');

    /* --- */

    vm.editMileage = editMileage;
    vm.isKeeperMileage = isKeeperMileage;
    vm.openKeeper = openKeeper;
    vm.openLetter = openLetter;
    vm.deleteKeeper = deleteKeeper;
    vm.createMileageRecord = createMileageRecord;
    vm.createVrm = createVrm;
    vm.createNote = createNote;
    vm.mileageEnabledChanged = mileageEnabledChanged;
    vm.vehicleId = $stateParams.vehicleId;
    vm.closeInvestigation = closeInvestigation;
    vm.openEditVehicle = openEditVehicle;
    vm.showCreateLetter = showCreateLetter;
    vm.showCreateLetterForKeeper = showCreateLetterForKeeper;
    vm.createKeeper = createKeeper;
    vm.moveKeeperUp = moveKeeperUp;
    vm.moveKeeperDown = moveKeeperDown;
    vm.contactStatus = contactStatus;

    /* --- */

    currentUser()
        .then(result => {
            vm.currentUser = result;
        });

    refreshScreen();

    tagSwitchService.subscribe('load-list', () => {
        checkInvestigationTag();
    });

    $scope.$watch(() => vm.mileages, () => updateMileages(), true);
    $scope.$watch(() => vm.keepers, () => setDontContactStatus(), true);

    /* --- */

    function refreshScreen() {
        getVehicle($stateParams.vehicleId)
        .then(x => {
            vm.details = x.details;
            vm.enquiries = x.enquiries;
            vm.keepers = x.keepers;
            vm.dealers = x.dealers;
            vm.mileages = x.mileages;
            vm.enquiries = x.enquiries;
            vm.notes = x.details.vehicleNotes;
            vm.discrepancies = x.discrepancies;
            vm.previousVrms = x.previousVrms;
            vm.lastEnquiryId = vm.enquiries[vm.enquiries.length - 1].id;
            vm.histories = x.histories;
        });
    }

    function setDontContactStatus() {
        for (let i = 0; i < vm.keepers.length; i++) {
            vm.keepers[i].dontContact = !vm.keepers[i].communicationStatus.allowedToSendCommunications;
        }
    }

    function editMileage(mileage) {
        openEditMileageModal($stateParams.vehicleId, mileage, vm.keepers);
    }

    function isKeeperMileage(mileage) {
        return mileage && (mileage.source === 'PointOfSale' || mileage.source === 'Purchase');
    }

    function openKeeper(keeper) {
        openKeeperModal($stateParams.vehicleId, keeper.id);
    }

    function openLetter() {
        console.log('TODO');
    }

    function showCreateLetterForKeeper(keeper) {
        openCreateLetterModal($stateParams.vehicleId, vm.keepers, keeper, 'keeper');
    }

    function showCreateLetter() {
        openCreateLetterModal($stateParams.vehicleId, vm.keepers, null, vm.dealers);
    }

    function createMileageRecord() {
        openAddMileageModal($stateParams.vehicleId, vm.mileages, vm.keepers);
    }

    function createVrm() {
        console.log('TODO');
    }

    function createNote() {
        openAddNoteModal(vm.notes, vm.discrepancies);
    }

    function mileageEnabledChanged(mileage) {
        if (!(vm.currentUser.isAdmin || vm.currentUser.isTeamLead)) {
            $state.go('noaccess');
            return;
        }

        updateMileageExcludedStatus($stateParams.vehicleId, mileage.id, mileage.excluded)
        .catch(() => {
            toaster.pop('error', `An error occured when ${ mileage.excluded ? 'excluding' : 'including' } the mileage`);
        });
    }

    function checkInvestigationTag() {
        if (vm.details) {
            getAllEnquiryTags($stateParams.vehicleId).then(response => {
                const investigationTag = response.find(element => {
                    return element.id === 5;
                });

                vm.details.isUnderInvestigation = investigationTag !== undefined && investigationTag !== null;
            });
        }
    }

    function closeInvestigation() {
        openCloseInvestigationModal(vm.notes);
    }

    function openEditVehicle() {
        openEditVehicleModal(vm.details);
    }

    function updateMileages() {
        // NOTE: we also order by id, just in case dates are the same
        vm.mileages = sortBy(vm.mileages, [x => new Date(x.dateRecorded), 'id']).reverse();
    }

    function createKeeper() {
        openCreateKeeperModel($stateParams.vehicleId, vm.keepers)
        .then(() => refreshScreen());
    }

    function moveKeeperUp(keeperId) {
        keeperMove($stateParams.vehicleId, keeperId, 'up')
        .then(() => {
            const keeper = vm.keepers.find(x => x.id === keeperId);
            const otherKeeper = vm.keepers.find(x => x.keeperPosition === keeper.keeperPosition - 1);

            keeper.keeperPosition--;
            otherKeeper.keeperPosition++;
        });
    }

    function moveKeeperDown(keeperId) {
        keeperMove($stateParams.vehicleId, keeperId, 'down')
        .then(() => {
            const keeper = vm.keepers.find(x => x.id === keeperId);
            const otherKeeper = vm.keepers.find(x => x.keeperPosition === keeper.keeperPosition + 1);

            keeper.keeperPosition++;
            otherKeeper.keeperPosition--;
        });
    }

    function contactStatus(keeperId) {
        const currentKeeper = vm.keepers.find(x => x.id === keeperId);
        keeperContact($stateParams.vehicleId, keeperId, currentKeeper.dontContact)
        .then(() => refreshScreen());
    }

    function deleteKeeper(keeperId, keeperPosition) {
        keeperDelete($stateParams.vehicleId, keeperId)
        .then(() => {
            vm.keepers = vm.keepers.filter(item => item.id !== keeperId);
            vm.keepers.forEach(keeper => keeper.keeperPosition = keeper.keeperPosition > keeperPosition ? keeper.keeperPosition - 1 : keeper.keeperPosition);
        });
    }
}



// WEBPACK FOOTER //
// ./Client/app/tasks/controllers/enquiries/details/enquiryDetailsCtrl.js